import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

const ANNOUNCEMENT_FIELDS = `
  id
  body
  asset { id }
  sale { id }
`;

const ANNOUNCEMENT_VARIABLES = `
  $assetId: ID!
  $saleId: ID!
  $body: String!
  $keepBids: Boolean!
`;

const ANNOUNCEMENT_ARGUMENTS = `
  assetId: $assetId
  saleId: $saleId
  body: $body
  keepBids: $keepBids
`;

const ANNOUNCEMENT_ACCEPTANCE_VARIABLES = `
  $announcementId: ID!
  $buyerUserId: ID!
`;

const ANNOUNCEMENT_FIELDS_AND_ERRORS = `
  announcement {
    ${ANNOUNCEMENT_FIELDS}
  }
  ${ERRORS}
`;

export const CREATE_ANNOUNCEMENT = gql`
  mutation CreateAnnouncement(
    ${ANNOUNCEMENT_VARIABLES}
  ) {
    createAnnouncement(
      ${ANNOUNCEMENT_ARGUMENTS}
    ) {
      ${ANNOUNCEMENT_FIELDS_AND_ERRORS}
    }
  }
`;